import { render, staticRenderFns } from "./Volumetria.vue?vue&type=template&id=0194e928&scoped=true&"
import script from "./Volumetria.vue?vue&type=script&lang=js&"
export * from "./Volumetria.vue?vue&type=script&lang=js&"
import style0 from "./Volumetria.vue?vue&type=style&index=0&id=0194e928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0194e928",
  null
  
)

export default component.exports